import React from "react";

function Barcode() {
  return (
    <>
      <section className="services" id="payment">
        <div className="container">
          <div className="row no-gutters">
            <div className="col-md-12">
              <div className="title text-center ">
                <h2>Our Services</h2>
              </div>
            </div>

            <div className="col-md-5">
              <p>
                <img
                  src="./images/barcode.png"
                  alt="Example1"
                  width="550"
                  height="550"
                ></img>
              </p>
            </div>
            <div className="col-md-1"></div>
            <div className=" col-md-6 bgcolor">
              <div className="text-center text-margin ">
                <h4 className="text-center text-color">
                  <b>BARCODE SOFTWARE IMPLEMENTATION</b>
                </h4>
                <p className="text-margin">
                  Barcodes are important to improve your business productivity,
                  speed, and accuracy. Barcode systems will help you track your
                  inventory, identify weak: areas of the supply chain, and
                  streamline your business tracks. Macrozion Techsystems provide
                  barcode software implementation services in cost-effective
                  ways. We follow the industry best practices of software
                  implementation and installation by developing a safe data
                  migration plan and ensuring data export and import from any
                  third-party system or legacy system. We can help you optimize
                  the value of your existing barcode hardware investments by
                  choosing, installing, and implementing the right software that
                  perfectly compliments your business needs.
                </p>

                <h5 className="text-color text-margin">
                  <b>Our Barcode Software Implementation Expertise</b>
                </h5>
                <ul className="text-color text-margin">
                  <li>
                    <b> 1. </b> Custom software development
                  </li>
                  <li>
                    <b> 2. </b> Functional system set up and Implementation
                  </li>
                  <li>
                    <b> 3. </b> Installation of on-premise and cloud-based
                    systems
                  </li>
                  <li>
                    <b> 4. </b>
                    Data migration and execution
                  </li>
                  <li>
                    <b> 5. </b> Technical support and customer care services
                  </li>
                  <li>
                    <b> 6. </b> Risk mitigation by identifying security risks
                    and license compliance issues
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Barcode;
